import { render, staticRenderFns } from "./room-im.vue?vue&type=template&id=037ba30c&scoped=true&"
import script from "./room-im.vue?vue&type=script&lang=js&"
export * from "./room-im.vue?vue&type=script&lang=js&"
import style0 from "./room-im.vue?vue&type=style&index=0&id=037ba30c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037ba30c",
  null
  
)

export default component.exports